import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from '@routingModule';
import { MaterialModule } from '@modules/material.module';
import { PrimengModule } from '@modules/primeng.module';

import { SharedModule } from '../../../shared/shared.module';
import { EditarLoteLancamentosApiService } from './services/cadastro-lote-lancamentos-api.service';
import { CadastroLoteLancamentosResolver } from './cadastro-lote-lancamentos.resolver';
import { CadastroLoteLancamentosComponent } from './components/cadastro-lote-lancamentos.component';
import { CardLoteLancamentosComponent } from './components/card-lote-lancamentos/card-lote-lancamentos.component';
import { CadastroLoteComponent } from './components/cadastro-lote/cadastro-lote.component';

@NgModule({
  declarations: [
    CadastroLoteLancamentosComponent,
    CardLoteLancamentosComponent,
    CadastroLoteComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    MaterialModule,
    PrimengModule,
  ],
  exports: [
    CadastroLoteComponent,
  ],
  providers: [
    { provide: EditarLoteLancamentosApiService, useClass: EditarLoteLancamentosApiService },
    CadastroLoteLancamentosResolver,
  ],
})
export class CadastroLoteLancamentosModule { }
